/**
 * Loading Spinner Component
 *
 * Displays a loading spinner with optional message
 */

import clsx from 'clsx';

export interface LoadingSpinnerProps {
  /** Size of spinner */
  size?: 'sm' | 'md' | 'lg';

  /** Optional message to display below spinner */
  message?: string;

  /** Center spinner on page */
  centered?: boolean;

  /** Additional CSS classes */
  className?: string;
}

const sizeClasses = {
  sm: 'w-4 h-4 border-2',
  md: 'w-8 h-8 border-2',
  lg: 'w-12 h-12 border-3',
};

/**
 * LoadingSpinner Component
 */
export function LoadingSpinner({
  size = 'md',
  message,
  centered = false,
  className,
}: LoadingSpinnerProps) {
  const spinner = (
    <div className={clsx('flex flex-col items-center gap-2', className)}>
      <div
        className={clsx(
          'animate-spin rounded-full border-zinc-300 border-t-zinc-900 dark:border-zinc-700 dark:border-t-zinc-100',
          sizeClasses[size]
        )}
        role="status"
        aria-label="Loading"
      />
      {message && <p className="text-sm text-zinc-600 dark:text-zinc-400">{message}</p>}
    </div>
  );

  if (centered) {
    return <div className="flex min-h-[400px] items-center justify-center">{spinner}</div>;
  }

  return spinner;
}
